import * as PIXI from "pixi.js";

import ServiceLocator from "../../ServiceLocator";
import ShopItem, { shop_item_state, shop_item_type } from "./ShopItem";
import DampedSpring from "../../lib/DampedSpring";
import { Signal } from "signals";


export default class ShopRow extends PIXI.Container
{
    // #region Attributes //

    // private:

    private _type: shop_row_type = null;
    private _items: Array<ShopItem> = null;

    private _scroll: PIXI.Container = null;
    private _arrScrollLimitY: Array<number> = null;
    private _isScrollDeadZone: boolean = null;
    private _scrollPointerY: number = null;
    private _arrScrollDeltaY: Array<number> = null;

    private _mouseWheelElapsedTime: number = null;
    private _bfWheel: any = null;

    private _dampedSpring: DampedSpring = null;

    private _im: PIXI.InteractionManager = null;
    
    private _onItemPurchased: Signal = null;

    // Constants.
    private readonly _kItemHeight: number = 545 * 0.5;
    private readonly _kItemMargin: number = 20;
    private readonly _kScrollItemMargin: number = this._kItemMargin + this._kItemHeight;

    // #endregion //


    // #region Properties //

    public set type( value: shop_row_type ) { this._type = value; }
    public set items( value: Array<ShopItem> ) { this._items = value; }

    public get items(): Array<ShopItem> { return this._items; }
    public get kScrollItemMargin(): number { return this._kScrollItemMargin; }

    public get onItemPurchased(): Signal { return this._onItemPurchased; }

    // #endregion //


    // #region Methods //

    // public:

    public init(): void
    {
        console.assert( this._type !== null, "ShopRow.ts :: init() :: this._type cannot be null." );
        console.assert( this._items != null, "ShopRow.ts :: init() :: this._items cannot be null." );

        this._onItemPurchased = new Signal();

        this.interactive = true;

        this._isScrollDeadZone = true;
        this._im = ServiceLocator.app.renderer.plugins.interaction;
        this._arrScrollDeltaY = [];
        this._mouseWheelElapsedTime = 0.1;

        this._scroll = new PIXI.Container();
        this.addChild( this._scroll );

        let rowCount: number = 0;
        let colIndex: number = 0;
        for ( let i: number = 0; i < this._items.length; ++i )
        {
            if ( i > 0 && i % 3 == 0 )
            {
                rowCount += 1;
                colIndex = 0;
            }

            let shopItem: ShopItem = this._items[ i ];
            shopItem.onSelected.add( this._onShopItem_Selected, this );
            shopItem.init();
            shopItem.position.set( colIndex * ( 194 + 29 ), rowCount * this._kScrollItemMargin );
            this._scroll.addChild( shopItem );

            colIndex += 1;
        }

        this._scroll.position.set( 
            /*ServiceLocator.app.width * 0.5 - ServiceLocator.resources.shop_product_base.texture.width * 0.5*/ 0,  
            280 );

        this._arrScrollLimitY = [ -( this._scroll.height - ServiceLocator.app.height + this._kItemMargin ), this._scroll.y ];

        //
        /*let g: PIXI.Graphics = new PIXI.Graphics();
        this.addChild( g );
        g.lineStyle( 2, 0xffffff, 1 );
        g.drawRect( 0, 0, this.width, this.height );*/

        this._dampedSpring = new DampedSpring();
        this._dampedSpring.springConstant = 100;
        this._dampedSpring.init();
        //
        this._dampedSpring.setFollower( this._scroll );

        ServiceLocator.app.stage.on( "pointerdown", this._onStage_PointerDown, this );

        this._bfWheel = this._onMouseWheel.bind( this );
        document.addEventListener( "wheel", this._bfWheel );
    }

        private _onShopItem_Selected( selShopItem: ShopItem ): void
        {
            switch ( selShopItem.state )
            {
                case shop_item_state.OWNED:
                    {
                        if ( selShopItem.type == shop_item_type.DART )
                        {
                            ServiceLocator.saved.data.selDartIndex = selShopItem.index;
                        }
                        else
                        {
                            ServiceLocator.saved.data.selBoardIndex = selShopItem.index;
                        }
                        ServiceLocator.saved.save();

                        for ( let displayObject of this._scroll.children )
                        {
                            let shopItem: ShopItem = displayObject as ShopItem;
                            if ( shopItem.state == shop_item_state.SELECTED )
                            {
                                shopItem.state = shop_item_state.OWNED;
                                shopItem.redraw();
                                break;
                            }
                        }

                        selShopItem.state = shop_item_state.SELECTED;
                        selShopItem.redraw();
                        break;
                    }

                case shop_item_state.UNLOCKED:
                    {
                        const kItemPrice: number = selShopItem.type == shop_item_type.DART ? ServiceLocator.resources.game_config.data.darts[ selShopItem.index ].price : ServiceLocator.resources.game_config.data.boards[ selShopItem.index ].price;
                        if ( ServiceLocator.saved.data.coins >= kItemPrice )
                        {
                            ServiceLocator.saved.data.coins -= kItemPrice;
                            ServiceLocator.saved.save();

                            for ( let displayObject of this._scroll.children )
                            {
                                let shopItem: ShopItem = displayObject as ShopItem;
                                if ( shopItem.state == shop_item_state.UNLOCKED )
                                {
                                    if ( shopItem == selShopItem )
                                    {
                                        selShopItem.state = shop_item_state.OWNED;
                                    }
                                    selShopItem.redraw();
                                }
                            }

                            this._onItemPurchased.dispatch( selShopItem );

                            this._onShopItem_Selected( selShopItem );
                        }
                        break;
                    }
            }
        }

        private _onStage_PointerDown(): void
        {
            if ( this._scroll.getBounds().contains( this._im.eventData.data.global.x, this._im.eventData.data.global.y ) )
            {
                this._scrollPointerY = this._im.eventData.data.global.y;

                ServiceLocator.app.stage.on( "pointermove", this._onStage_PointerMove, this );
                ServiceLocator.app.stage.on( "pointerup", this._onStage_PointerUp, this );
                ServiceLocator.app.stage.on( "pointerupoutside", this._onStage_PointerUp, this );
            }
        }

            private _onStage_PointerMove(): void
            {
                if ( this._isScrollDeadZone )
                {
                    if ( Math.abs( this._scrollPointerY - this._im.eventData.data.global.y ) >= 10 )
                    {
                        this._isScrollDeadZone = false;
                        for ( let shopItem of this._scroll.children )
                        {
                            ( shopItem as ShopItem ).setEnabled( false );
                        }

                        this._scrollPointerY = this._im.eventData.data.global.y;
                    }
                }
                else
                {
                    const dy: number = ( this._im.eventData.data.global.y - this._scrollPointerY ) * 2 / ServiceLocator.app.root.scale.x;
                    this._arrScrollDeltaY.push( dy );

                    this._scrollPointerY = this._im.eventData.data.global.y;
                }
            }

            private _onStage_PointerUp(): void
            {
                this._scrollPointerY = null;

                this._isScrollDeadZone = true;
                for ( let shopItem of this._scroll.children )
                {
                    ( shopItem as ShopItem ).setEnabled( true );
                }

                ServiceLocator.app.stage.off( "pointermove", this._onStage_PointerMove, this );
                ServiceLocator.app.stage.off( "pointerup", this._onStage_PointerUp, this );
                ServiceLocator.app.stage.off( "pointerupoutside", this._onStage_PointerUp, this );
            }

        private _onMouseWheel( event: WheelEvent )
        {
            this._arrScrollDeltaY.push( event.deltaY > 0 ? -200 : 200 );

            this._mouseWheelElapsedTime = 0;
        }

    public end(): void
    {        
        this._onItemPurchased.dispose();
        this._onItemPurchased = null;

        ServiceLocator.app.stage.off( "pointerdown", this._onStage_PointerDown, this );
        document.removeEventListener( "wheel", this._bfWheel );
        this._bfWheel = null;

        this.onLeft();

        for ( let displayObject of this._scroll.children )
        {
            ( displayObject as ShopItem ).end();
        }
    }

    public update( dt: number ): void
    {
        if ( this._mouseWheelElapsedTime < 0.1 )
        {
            this._mouseWheelElapsedTime += dt;
        }

        for ( let displayObject of this._scroll.children )
        {
            ( displayObject as ShopItem ).update( dt );
        }

        let targetY: number = this._dampedSpring.target.y;
        for ( let scrollDeltaY of this._arrScrollDeltaY )
        {
            targetY += scrollDeltaY;
        }
        if ( targetY < this._arrScrollLimitY[ 0 ] )
        {
            window.setTimeout( () => { this._dampedSpring.setTarget( this._dampedSpring.target.x, this._arrScrollLimitY[ 0 ] ); }, 50 );
        }
        else if ( targetY > this._arrScrollLimitY[ 1 ] )
        {
            window.setTimeout( () => { this._dampedSpring.setTarget( this._dampedSpring.target.x, this._arrScrollLimitY[ 1 ] ); }, 50 );
        }
        this._arrScrollDeltaY.splice( 0 );
        this._dampedSpring.setTarget( this._dampedSpring.target.x, targetY );
        this._dampedSpring.update( dt );
    }

    public resetScroll(): void
    {
        this._arrScrollDeltaY.splice( 0 );
        this._dampedSpring.clear();
        this._dampedSpring.setFollower( this._scroll );
        this._scroll.y = 280;
    }

    public onEntered(): void
    {
        /*if ( this._type == shop_row_type.POWERUP )
        {
            ServiceLocator.game.adManager.onAdReady.add( this._onPowerupAd_Ready, this );
            ServiceLocator.game.adManager.onAdLost.add( this._onPowerupAd_Lost, this );
            ServiceLocator.game.adManager.onAdCompleted.add( this._onPowerupAd_Completed, this );

            ServiceLocator.game.adManager.prepare();
        }*/
    }

    public onLeft(): void
    {
        /*if ( this._type == shop_row_type.POWERUP )
        {
            ServiceLocator.game.adManager.onAdReady.remove( this._onPowerupAd_Ready, this );
            ServiceLocator.game.adManager.onAdLost.remove( this._onPowerupAd_Lost, this );
            ServiceLocator.game.adManager.onAdCompleted.remove( this._onPowerupAd_Completed, this );
            
            if ( this._nextAdTimeout )
            {
                window.clearTimeout( this._nextAdTimeout );
                this._nextAdTimeout = null;
            }
        }*/
    }

    // #endregion //
}

export const enum shop_row_type
{
    DART = 0,
    BOARD
}